// Lib
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Flex, Heading, Button } from 'rebass';

// Components
import ErrorMessage from 'components/ErrorMessage';
import ModalContent from '../ModalContent';

const Content = styled(ModalContent)`
  max-width: 415px;
  width: 100%;
  flex-direction: column;
  padding-bottom: 30px;
`;

const ModalButton = styled(Button)`
  width: 150px;
  font-size: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

interface ConfirmProps {
  closeModalHandler: VoidFunction;
}

const Confirm: React.FC<ConfirmProps> = (props): JSX.Element => {
  const { closeModalHandler } = props;
  const { loading } = useSelector<any, any>(state => state);
  const { title, confirmHandler, error } = useSelector<any, any>(state => state.modal.data);
  return (
    <Content>
      <Flex width="100%" flexDirection="column" px={3} pt={4}>
        <Heading fontSize="26px" fontWeight={6} textAlign="center" mb={2}>
          {title}
        </Heading>
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </Flex>
      <Flex mt={5} justifyContent="center">
        <ModalButton variant="primary" mr={3} onClick={closeModalHandler}>
          Cancel
        </ModalButton>
        <ModalButton variant={loading ? 'disabled' : 'primary'} onClick={confirmHandler}>
          Confirm
        </ModalButton>
      </Flex>
    </Content>
  );
};

export default Confirm;
